import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  {
    title: 'pages.onboarding.aiWitness.impressive',
    subtitle: 'pages.onboarding.aiWitness.impressiveSub',
    value: 'impressive',
  },
  {
    title: 'pages.onboarding.aiWitness.unsettling',
    subtitle: 'pages.onboarding.aiWitness.unsettlingSub',
    value: 'unsettling',
  },
  {
    title: 'pages.onboarding.aiWitness.heardStories',
    subtitle: 'pages.onboarding.aiWitness.heardStoriesSub',
    value: 'heard-stories',
  },
  {
    title: 'pages.onboarding.aiWitness.notReally',
    subtitle: 'pages.onboarding.aiWitness.notReallySub',
    value: 'not-really',
  },
]

export default function AiWitnessPage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.aiWitness.title"
    />
  )
}
